<template>
  <div class="info-strip">
    <!-- 保证金预存服务标签 -->
    <div class="service-tag">
      <div class="tag-main">
        <img
          src="@/assets/images/supplier/guarantee-pre-save/service-icon-round.png"
          alt=""
        />
        <div class="flex-col">
          <div class="main-title">灵活宝</div>
          <div class="main-sub-title">保证金预存</div>
        </div>
      </div>
      <el-divider />
      <div class="tag-second">目前只支持询比型项目保证金缴纳</div>
    </div>
    <div class="strip-content">
      <!-- 保证金预存额度信息 -->
      <div class="service-quota">
        <div class="quota-item">
          <div class="quota-item-label">企业共享保证金总额度</div>
          <div class="quota-item-value">
            <span class="quota-item-value__num">
              {{ guaranteePreSave.useTotalAmount }}
            </span>
            元
          </div>
          <div class="quota-item-tip">
            企业共享保证金额度=预存账户余额
          </div>
        </div>
        <div class="quota-item">
          <div class="quota-item-label">占用中额度</div>
          <div class="quota-item-value primary">
            <span
              class="quota-item-value__num clickable"
              @click="openOccupyDialog"
            >
              {{ guaranteePreSave.consumeTotalAmount }}
            </span>
            元
          </div>
          <div class="quota-item-tip">
            项目结束后解除占用额度
          </div>
        </div>
        <div class="quota-item">
          <div class="quota-item-label">剩余可用额度</div>
          <div class="quota-item-value">
            <span class="quota-item-value__num">
              {{ guaranteePreSave.remainTotalAmount }}
            </span>
            元
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="额度占用明细"
      class="dialog"
      :visible.sync="occupyVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <div class="occupy-tip">
        项目完结或者流标后，保证金占用额度自动解除占用。
      </div>
      <jczh-table-content
        :data="occupyList"
        :option="occupyListOption"
        pagination
        :total="total"
        :page.sync="page"
        :limit.sync="size"
        @pagination="getOccupyList"
      />
      <template v-slot:footer>
        <el-button type="primary" @click="occupyVisible = false">
          关闭
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { guaranteePreSaveOccupyStatusDict } from '@/dictionary/financial'
import { getGuaranteePreSaveConsumePageApi } from '@/api/guarantee-pre-save'

/**
 * 保证金预存信息条
 */
export default {
  name: 'GuaranteePreSaveStrip',

  data() {
    return {
      // 占用额度弹窗显示
      occupyVisible: false,
      occupyList: [],
      occupyListOption: [
        { label: '项目名称', prop: 'projectName' },
        { label: '保证金占用额度（元）', prop: 'amount' },
        { label: '开始占用时间', prop: 'consumeTime' },
        { label: '占用结束时间', prop: 'recoverTime' },
        {
          label: '占用状态',
          prop: 'recoverStatus',
          filter: value =>
            guaranteePreSaveOccupyStatusDict.translate(value)?.label
        },
        { label: '员工姓名', prop: 'employeeName' }
      ],
      page: 1,
      size: 10,
      total: 0
    }
  },

  computed: {
    ...mapState('finance', ['guaranteePreSave'])
  },

  created() {
    this.getPreSaveAccount()
  },

  methods: {
    /**
     * 获取预存账户信息
     */
    getPreSaveAccount() {
      this.$store.dispatch('finance/getGuaranteePreSave')
    },

    openOccupyDialog() {
      this.occupyVisible = true
      this.getOccupyList()
    },

    getOccupyList() {
      const params = {
        pageNum: this.page,
        pageSize: this.size
      }
      getGuaranteePreSaveConsumePageApi(params)
        .then(res => {
          this.occupyList = res.data?.records || []
          this.total = res.data?.total || 0
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.info-strip {
  width: 100%;
  background: $white-color;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
}

.service-tag {
  background: $primary-color;
  color: $white-color;
  width: 221px;
  height: 100%;
  padding: 16px 16px 20px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ::v-deep .el-divider--horizontal {
    height: 1px;
    margin: 18px 0 14px 0;
    background: #EEF6FF;
    opacity: 0.5;
  }

  .tag-main {
    display: flex;
    align-items: center;

    img {
      width: 54px;
      height: 54px;
      margin-right: 16px;
    }

    .main-title {
      font-size: 24px;
      @include text-bold;
      line-height: 34px;
    }

    .main-sub-title {
      font-size: 16px;
      line-height: 18px;
    }
  }

  .tag-second {
    color: $white-color;
    font-size: 14px;
    line-height: 20px;
  }
}

.strip-content {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}

.service-quota {
  flex: 1;
  display: flex;
  align-items: stretch;
  justify-content: space-evenly;
  padding: 24px;

  .quota-item {
    min-width: 160px;

    &-label {
      font-size: 16px;
      color: $second-text-color;
      margin-bottom: 12px;
      line-height: 18px;
    }

    &-value {
      color: $text-color;
      font-size: 18px;

      &__num {
        font-size: 36px;
        line-height: 36px;
        color: $text-color;
      }

      &.primary {
        color: $primary-color;

        .quota-item-value__num {
          color: $primary-color;
        }
      }
    }

    &-tip {
      margin-top: 22px;
      color: $third-text-color;
      font-size: 14px;
      line-height: 18px;
    }
  }
}

.occupy-tip {
  margin-bottom: 16px;
  color: $third-text-color;
}
</style>
